var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-header",class:[_vm.type]},[(_vm.heading)?_c('h2',[_vm._v(_vm._s(_vm.heading))]):_vm._e(),_vm._v(" "),(_vm.text)?_c('p',[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }